import { JSX, useEffect, useRef } from 'react';

// Loading canvas component
function LoadingCanvas({ progress }: { progress: number }): JSX.Element {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Clear canvas
    ctx.fillStyle = '#1a1a1a';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw loading text
    ctx.fillStyle = '#ffffff';
    ctx.font = '20px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    ctx.fillText('Downloading...', centerX, centerY - 20);
    ctx.fillText(`${Math.round(progress)}%`, centerX, centerY + 20);

    // Draw progress bar
    const barWidth = 200;
    const barHeight = 10;
    const barX = centerX - barWidth / 2;
    const barY = centerY + 40;

    // Background bar
    ctx.fillStyle = '#333333';
    ctx.fillRect(barX, barY, barWidth, barHeight);

    // Progress bar
    ctx.fillStyle = '#4CAF50';
    ctx.fillRect(barX, barY, (barWidth * progress) / 100, barHeight);

  }, [progress]);

  return (
    <div className='canvas-container'>
      <canvas
        ref={canvasRef}
        className="border border-gray-300 rounded-lg"
        style={{ display: 'block' }}
      />
    </div>
  );
}
export default LoadingCanvas;
